import React from "react";
import useRole from "../Provider/TableContext/RoleContext";
import { useLocation, useNavigate } from "react-router";
import RoleStatus from '../Constants/RoleStatus.json';

export default function useProfileCompletionCheck() {
    const { roles, loading } = useRole();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    React.useEffect(() => {
        if (
            !loading
            && !roles.filter(({mcb_rolestatus}) => (
                mcb_rolestatus === RoleStatus.Current
                || mcb_rolestatus === RoleStatus.Previous
            )).length
            && !pathname.startsWith("/profile")
        ) {
            const confirmationMessage = encodeURI("Please enter atleast one Profession you have been in.");
            let timeout = setTimeout(() => {
                navigate(`/profile/professional?confirm=${confirmationMessage}&cancel=%2fsign-out&returnUrl=%2fsign-out`) 
            }, 300);
            
            return () => { clearTimeout(timeout) };
        } 
    }, [roles, loading, pathname, navigate])
}
